import { createContext, useContext, type ReactNode } from "react";

import type { InsightsContext } from "./types";

const InsightsCtx = createContext<InsightsContext | null>(null);

export function InsightsProvider({
  value,
  children,
}: {
  value: InsightsContext;
  children: ReactNode;
}) {
  return <InsightsCtx.Provider value={value}>{children}</InsightsCtx.Provider>;
}

export function useInsightsContext(): InsightsContext {
  const ctx = useContext(InsightsCtx);
  if (!ctx) {
    throw new Error(
      "useInsightsContext must be used within an InsightsProvider",
    );
  }
  return ctx;
}

/**
 * Non-throwing variant for components that can render both inside the Insights
 * provider and in other contexts (e.g. the Messages tab, which reuses
 * breakdown data but lives outside `/ai/insights`). Returns `null` when no
 * provider is present so the caller can fall back to prop-supplied data.
 */
export function useInsightsContextOptional(): InsightsContext | null {
  return useContext(InsightsCtx);
}
